import { ConversationsData, fetchConversations } from '@nextforce/api'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { getRecentMessagesFromCache } from 'chat/messages/queries/shared/utils'
import { RetryQuery } from 'shared/queries/utils'
import { useUser } from 'users/queries/detail'
import keys from '../../shared/queries/keys'

export function useConversations(retryQuery?: RetryQuery) {
  const { server } = useServer()
  const client = useQueryClient()
  const { data: user } = useUser()

  return useQuery<ConversationsData>({
    queryKey: keys.conversations(),
    queryFn: fetchConversationsWithStatus,
    enabled: !!user?.permissions?.canSeeMessages,
    retry: retryQuery ?? false,
    refetchOnMount: 'always',
  })

  async function fetchConversationsWithStatus(): Promise<ConversationsData> {
    const conversations = await fetchConversations(server)
    const recentMessageMap = getRecentMessagesFromCache(client)

    return conversations.map(conversation => ({
      ...conversation,
      status: {
        lastViewedTimestamp: conversation.status?.lastViewedTimestamp,
        recentMessage: recentMessageMap?.[conversation.id],
      },
    }))
  }
}
